import ArticleInfo from '@/components/BlogComponents/shared/ArticleInfo/ArticleInfo';
import ResponsiveImage from '@/components/Image/ResponsiveImage';
import Link from '@/components/Link/Link';
import type { BlogPageType } from '@/contentful/api/api.types';
import useGlobalStyles from '@/styles/global.styles';

import useStyles from './FeaturedArticle.styles';

type FeaturedArticle = {
  article: BlogPageType;
};

const FeaturedArticle = ({ article }: FeaturedArticle) => {
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });
  const { classes, cx } = useStyles();

  const { heroImage, readTimeMinutes, path, heroImageAltText, blogTitle } =
    article;

  return (
    <div className={classes.wrapper}>
      {/** biome-ignore lint/complexity/useOptionalChain: Automated migration to Biome */}
      {heroImage && heroImage[0] && (
        <>
          <div className={classes.imageWrapper}>
            <ResponsiveImage
              src={heroImage[0]}
              alt={heroImageAltText || ''}
              className={classes.image}
              sizes={{ xs: 592, sm: 468, md: 656, lg: 600 }}
            />
          </div>
          <h3 className={cx(globalClasses.h3, classes.title)}>
            <Link href={path} title={blogTitle}>
              {blogTitle}
            </Link>
          </h3>
        </>
      )}
      <ArticleInfo readingTime={readTimeMinutes} />
    </div>
  );
};

export default FeaturedArticle;
